import React, {Component} from 'react';
import Input from '../../components/UI/Input/FormInput';
import {Button, Col, FormGroup, Input as InputUncontrolled, Label, Row} from 'reactstrap';
import PhoneNumber from 'awesome-phonenumber';
import SMSVotingProcessStepOne from '../../components/UI/ReCarousel/CarouselAssets/SMSVotingProcessStepOneMobile';
import SMSVotingProcessStepTwo from '../../components/UI/ReCarousel/CarouselAssets/SMSVotingProcessStepTwoMobile';
import SMSVotingProcessStepThree from '../../components/UI/ReCarousel/CarouselAssets/SMSVotingProcessStepThree';
import SMSVotingProcessStepOneDesktop
    from '../../components/UI/ReCarousel/CarouselAssets/SMSVotingProcessStepOneDesktop';
import SMSVotingProcessStepThreeDesktop
    from '../../components/UI/ReCarousel/CarouselAssets/SMSVotingProcessStepThreeDesktop';
import ReCarousel from "../../components/UI/ReCarousel/ReCarousel";
import Cookies from "js-cookie";
import moment from 'moment';
import {Helmet} from "react-helmet";
import {sendVirtualPageView} from "../../shared/utility";
import KeyVisual from "../../components/UI/ResponsiveImageSet/ResponsiveImageSet";
import KeyVisualXs from "../../assets/images/keyvisual-xs-rgb.webp";
import KeyVisualLg from "../../assets/images/keyvisual-lg-rgb.webp";
import axios from "../../axios-base";
import {Link} from "react-router-dom";
import CampaignMetrics from "../../components/CampaignMetrics/CampaignMetrics";

class SMSRequest extends Component {
    constructor(props) {
        super(props);
        const windowSize = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const renderCarousel = windowSize < 575;

        this.state = {
            userInput: '',
            pn: '',
            touched: false,
            formIsValid: false,
            desiredSlide: 0,
            renderCarousel,
            windowSize,
            SVGOne: <SMSVotingProcessStepOne
                afterInjection={(e) => this.setState({flexibleHeight: this.calculateFlexibleHeight(e)})}/>,
            SVGTwo: <SMSVotingProcessStepTwo/>,
            SVGThree: <SMSVotingProcessStepThree/>,
            SVGOneDesktop: <SMSVotingProcessStepOneDesktop/>,
            SVGThreeDesktop: <SMSVotingProcessStepThreeDesktop/>,
            submitSuccess: false,
            flexibleHeight: 0,
            captchaContainerVisibility: false
        }

        this.navigationHandler = this.navigationHandler.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.calculateFlexibleHeight = this.calculateFlexibleHeight.bind(this);
        this.returnLinkRef = React.createRef();
    }

    timer;

    componentDidMount() {
        window.addEventListener("resize", this.onResizeHandler);
        sendVirtualPageView("Jetzt Abstimm-Code anfordern")
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResizeHandler);
        clearTimeout(this.timer);
    }

    navigationHandler() {
        this.clickChild(this.state.desiredSlide);
    };

    calculateFlexibleHeight(svg) {
        const assetWidth = svg.viewBox.baseVal.width;
        const assetHeight = svg.viewBox.baseVal.height;
        return ((assetHeight / assetWidth) * this.state.windowSize) - 15;
    }

    onChangeHandler = event => {
        let userInput = event.target.value;
        let pn = PhoneNumber(userInput, 'DE');
        let formattedOutput = pn.getNumber('national');

        this.setState({
            userInput: userInput,
            pn: formattedOutput,
            touched: true,
            formIsValid: pn.isMobile() && pn.isValid()
        }, () => {
            if (this.state.renderCarousel) {
                if (this.state.formIsValid) {
                    this.setState({desiredSlide: 1}, () => {
                        this.navigationHandler();
                    })
                } else {
                    this.setState({desiredSlide: 0}, () => {
                        this.navigationHandler();
                    })
                }
            } else {
                if (this.state.formIsValid) {
                    this.setState({desiredSlide: 1})
                } else {
                    this.setState({desiredSlide: 0})
                }
            }
        });
    }

    onVoteHandler = () => {
        this.requestSMS()
    };

    requestSMS() {
        let request;

        if (process.env.REACT_APP_AWS_WAF_INTEGRATION_USE === 'true') {
            request = window.AwsWafIntegration.getToken().catch(err => {
                this.handleUnsuccessfulSMSRequest(err);
            }).then(token => {
                return axios.post('/sms',
                    {recipient: this.state.pn},
                    {
                        headers: {
                            'x-aws-waf-token': token,
                        }
                    }
                )
            });
        } else {
            request = axios.post('/sms', {recipient: this.state.pn})
        }

        request.then(response => {
            if (response.status === 201) {
                this.redirectUser();
            } else {
                this.handleUnsuccessfulSMSRequest(response);
            }
        }).catch(err => {
            if (err.response.status === 405) {
                //hide sms request button
                this.setState({captchaContainerVisibility: true}, () => {
                    // only then display captcha
                    this.displayCaptchaPuzzle();
                })
            } else {
                this.handleUnsuccessfulSMSRequest(err);
            }
        })
    }

    displayCaptchaPuzzle = () => {
        const container = document.querySelector("#captcha-container");
        window.AwsWafCaptcha.renderCaptcha(container, {
            apiKey: process.env.REACT_APP_AWS_WAF_CAPTCHA_KEY,
            onSuccess: this.onCaptchaVerified,
            dynamicWidth: true,
            defaultLocale: "de-DE"
        });
    }

    onCaptchaVerified = () => {
        //Called on Successful Captcha
        //Hide captcha success message to remove confusion in voting process
        // Display voting button as animation progress and redirect are shown within it
        this.setState({
            captchaContainerVisibility: false
        }, () => {
            // only then display captcha
            this.onVoteHandler();
        })
    }

    redirectUser = () => {
        // offer redirect User to projects page
        const focusReturnLink = () => {
            if (this.state.renderCarousel) {
                this.navigationHandler(); // Navigate carousel to success slide
            }
            // Ensure focus happens after state update and potential DOM re-render
            setTimeout(() => {
                if (this.returnLinkRef.current) {
                    this.returnLinkRef.current.focus();
                }
            }, 0);
        };

        this.setState({
            desiredSlide: 2,
            submitSuccess: true
        }, focusReturnLink);

        if (!Cookies.get('bigfoot_code-requested')) {
            Cookies.set('bigfoot_code-requested', true, {expires: 7});
        }
    }

    handleUnsuccessfulSMSRequest = (responseOrError) => {
        // Check if it's a fetch response or an error object
        this.redirectUser();
    }

    onResizeHandler = () => {
        let renderCarousel;
        let windowSize = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth

        renderCarousel = windowSize < 575;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.setState({
                windowSize: windowSize,
                renderCarousel: renderCarousel
            });
        }, 500)
    }

    render() {
        let SMSVotingProcess;
        let initialButtonText = 'Bitte gültige Mobilnummer angeben';
        let form;
        // @Todo: Refactor dynamic form into its own component
        let DynamicForm = ({children}) => {
            return <React.Fragment>
                <FormGroup className="mb-2">
                    <Label for="voteEnded">Ihre Mobilnummer</Label>
                    <InputUncontrolled id="voteEnded" disabled className="mb-2" placeholder="0123 4567890"/>
                </FormGroup>
                <Row>
                    <Col>
                        {children}
                    </Col>
                </Row>
            </React.Fragment>
        };
        const ImageSetMobile = [this.state.SVGOne, this.state.SVGTwo, this.state.SVGThree];
        const ImageSetDesktop = [this.state.SVGOneDesktop, this.state.SVGTwo, this.state.SVGThreeDesktop];

        if (this.state.renderCarousel) {
            SMSVotingProcess = (
                <Col>
                    {/*flexible height is calculated after image load*/}
                    <div style={{height: this.state.flexibleHeight, userSelect: "none"}}>
                        <ReCarousel axis={"x"} className="re-carousel" setClick={click => this.clickChild = click}
                                    desiredSlide={this.state.desiredSlide} onStartFrameIndex={this.state.desiredSlide}>
                            {ImageSetMobile.map((image, index) => (
                                <div style={index === this.state.desiredSlide ? {transition: '1s'} : {
                                    filter: 'grayscale(1)',
                                    transition: '1s'
                                }}
                                     key={index}>
                                    {image}
                                </div>
                            ))}
                        </ReCarousel>
                    </div>
                </Col>
            );
        } else {
            SMSVotingProcess = ImageSetDesktop.map((image, index) => {
                return (
                    <Col style={index === this.state.desiredSlide ? {transition: '100ms'} : {
                        filter: 'grayscale(1)',
                        transition: '100ms'
                    }}
                         key={index}>
                        {image}
                    </Col>
                )
            });
        }

        if (this.state.formIsValid) {
            initialButtonText = 'Jetzt Code anfordern';
        }

        const MultiButton = () => {
            if (!this.state.submitSuccess) {
                // Determine button text based on form validity
                const currentButtonText = this.state.formIsValid ? 'Jetzt Code anfordern' : 'Bitte gültige Mobilnummer angeben';
                return (
                    <Button
                        block
                        className="position-relative w-100 anl_sms--request"
                        disabled={!this.state.formIsValid}
                        color="primary"
                        onClick={this.onVoteHandler}
                    >
                        {currentButtonText}
                    </Button>
                );
            } else {
                return (
                    <Link className="text-decoration-none"
                        to={Cookies.get('bigfoot_redirect-category') ?
                        `/projekte/?category=${Cookies.get('bigfoot_redirect-category')}`
                        : '/projekte/'}
                          title="Abstimm-Code erfolgreich angefordert. Jetzt zur Projektliste navigieren und für das Wunschprojekt abstimmen."
                        ref={this.returnLinkRef}
                    >
                        <Button
                            block
                            color="success"
                            className="position-relative w-100 anl_sms--skip-redirect"
                            aria-hidden={true}
                        >
                            Jetzt für das Wunschprojekt abstimmen
                        </Button>
                    </Link>
                );
            }
        };

        const PHONENUMBERCONFIG = {
            elementType: "input",
            elementConfig: {
                type: "text",
                inputMode: "numeric",
                pattern: "[0-9 ]+",
                placeholder: "0123 4567890",
                label: "Ihre Mobilnummer",
                columns: 12,
                disabled: this.state.submitSuccess
            },
            validation: {
                required: {value: true, errorMessage: "Bitte geben Sie eine gültige Mobilnummer an"},
                maxLength: {value: 11, errorMessage: "Bitte geben Sie eine gültige Mobilnummer an"},
                minLength: {value: 10, errorMessage: "Bitte geben Sie eine gültige Mobilnummer an"}
            },
            errorMessage: 'Bitte geben Sie eine gültige Mobilnummer an',
            ifAuth: false
        }

        if (!this.props.votingPhases.votingStarted) {
            form = (
                <DynamicForm>
                    <Button block disabled color="primary"
                            style={{cursor: 'not-allowed'}}>Die Abstimmung startet
                        am {moment(this.props.votingPhases.voteStart).format('DD.MM.')}</Button>
                </DynamicForm>
            );
        } else if (this.props.votingPhases.votingStarted && !this.props.votingPhases.votingEnded && this.props.balance > 0) {
            form = (
                <React.Fragment>
                    <FormGroup row className="mb-0">
                        <Input
                            autoFocus={true}
                            name="mobilePhoneNumber"
                            elementType={PHONENUMBERCONFIG.elementType}
                            elementConfig={PHONENUMBERCONFIG.elementConfig}
                            value={this.state.formIsValid ? this.state.pn : this.state.userInput}
                            changed={(event) => this.onChangeHandler(event)}
                            shouldValidate={PHONENUMBERCONFIG.validation}
                            touched={this.state.touched}
                            errorMessage={PHONENUMBERCONFIG.errorMessage}
                            invalid={!this.state.formIsValid}
                            formText={PHONENUMBERCONFIG.formText}
                            wrapperCSSClass="mb-2"
                        />
                    </FormGroup>
                    <div className={`w-100 ${this.state.captchaContainerVisibility ? "" : "d-none"}`}
                         id="captcha-container"/>
                    {
                        !this.state.captchaContainerVisibility && (
                            <Row>
                                <Col>
                                    <MultiButton/>
                                </Col>
                            </Row>
                        )
                    }
                </React.Fragment>
            )
        } else if (this.props.votingPhases.votingEnded) {
            form = (
                <DynamicForm>
                    <Button block disabled color="primary"
                            style={{cursor: 'not-allowed'}}>Der Wettbewerb ist beendet</Button>
                </DynamicForm>
            );
        } else {
            form = (
                <DynamicForm>
                    <Button block disabled color="primary"
                            style={{cursor: 'not-allowed'}}>Die Mittel sind erschöpft!</Button>
                </DynamicForm>
            );
        }

        return (
            <React.Fragment>
                <Helmet>
                    <title>{`Jetzt Abstimm-Code anfordern | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
                </Helmet>
                <Row>
                    <Col className="px-0">
                        <KeyVisual imageXs={KeyVisualXs} imageLg={KeyVisualLg}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CampaignMetrics />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <h2>So funktioniert die Abstimmung</h2>
                    </Col>
                </Row>
                <Row>
                    {SMSVotingProcess}
                </Row>
                <Row className="my-1">
                    <Col className="col-12 col-lg-4 col-md-5">
                        {form}
                    </Col>
                    <Col className="col-12 col-lg-8 col-md-7 mt-3">
                        <h2>So stimmen Sie ab</h2>
                        <p>Während der Abstimmung fordern Sie auf dieser Seite durch die Eingabe Ihrer Mobilfunknummer
                            einen Abstimm-Code an. Dieser wird Ihnen kostenlos per SMS zugestellt. Ein Abstimm-Code
                            entspricht jeweils einer Stimme und ist für 48 Stunden gültig. Jeder Abstimm-Code besteht
                            aus einer Kombination von acht Buchstaben und Zahlen, Sonderzeichen sind nicht enthalten.
                            Diesen Abstimm-Code geben Sie auf dem Profil Ihres Favoriten ein, um für diesen
                            abzustimmen.</p>
                        <p>Es kann nur ein Abstimmcode pro Mobilfunknummer angefordert werden, Sie haben also genau eine
                            Stimme für Ihren Favoriten. Nur deutsche Mobilfunknummern können teilnehmen. Der SMS-Empfang
                            innerhalb Deutschlands ist kostenlos, es entstehen durch die Abstimmung keine Kosten. Die
                            Mobilfunknummern dienen ausschließlich der Abstimmung, sie werden nicht für Werbezwecke
                            verwendet. Bis zum Ablauf des Wettbewerbs werden sie verschlüsselt gespeichert und danach
                            vollständig gelöscht.</p>

                        <h2>Ich habe keine SMS mit Abstimmcode erhalten?</h2>
                        <p>Haben Sie sich eventuell vertippt? Gehen Sie sicher, dass Sie die richtige Mobilfunknummer
                            angegeben haben.</p>
                        <p>Die SMS mit dem Abstimmcode werden nach Eingabe einer gültigen deutschen Mobilfunknummer
                            automatisch versendet. Das Versenden der Codes kann bei starker Nachfrage in Ausnahmefällen
                            etwas dauern. Dies kann auch in Spitzenzeiten der jeweiligen Netzbetreiber der Fall sein,
                            jedoch sollten alle SMS in der Folge zugestellt werden. Sobald wir die SMS an Ihren
                            Mobilfunkprovider übergeben haben, obliegt die Zustellung der SMS dem jeweiligen
                            Netzanbieter. Um eine sichere Abstimmung zu gewährleisten und Ihre Daten zu schützen, können
                            wir keine einzelnen Mobilfunknummern zurückverfolgen und bestimmten Codes zuordnen. Auf die
                            Zustellung können wir nach der Übergabe an den Mobilfunkprovider leider keinen Einfluss mehr
                            nehmen. Eine erneute Versendung von Codes ist daher auch nicht möglich.</p>

                        <h2>Was geschieht mit den eingegebenen Mobilfunknummern?</h2>
                        <p>Die Angabe der Mobilfunknummer dient lediglich der Verifizierung der Stimme.
                            Mobilfunknummern, die für die Abstimmung verwendet wurden, werden zehn Tage nach Beendigung
                            des Wettbewerbs vollumfänglich gelöscht und zu keinem Zeitpunkt für eine weitere Nutzung
                            außer für den Versand des Abstimmcodes per SMS verwendet. Die Mobilfunknummern werden
                            mehrfach verschlüsselt gespeichert. Eine Weitergabe der Daten erfolgt nicht.</p>

                        <h2>Wenn ich auf Abstimmen klicke, passiert nichts.</h2>
                        <p>Möglicherweise ist dies auf eine veraltete Browserversion zurückzuführen. Bitte achten Sie
                            darauf immer die aktuellen Updates Ihres Browsers zu installieren. Insbesondere der Internet
                            Explorer wird von uns nicht mehr unterstützt, da dieser nicht mehr mit den neuesten
                            Technologien kompatibel ist. Wir empfehlen moderne Alternativen wie Firefox oder Google
                            Chrome zu verwenden.</p>
                        <p>Eine weitere Möglichkeit ist, dass ein Ad Blocker das Abstimmen verhindert. Haben Sie einen
                            Ad Blocker installiert? Diese können das Laden von einigen Skripten der Homepage verhindern.
                            Sie können Ihren Ad Blocker für die Abstimmung kurz deaktivieren oder das Plug-In nur für
                            unsere Website deaktivieren. Dann sollte die Abstimmung in der Regel problemlos
                            funktionieren.</p>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default SMSRequest;